import { SIQLauncherUnreadBadgeTheme } from "./SIQLauncherUnreadBadgeTheme";
export class SIQConversationListItemTheme {
  backgroundColor = "null";
  timerTextColor = "null";
  timerIconColor = "null";
  titleTextColor = "null";
  subtitleTextColor = "null";
  timeTextColor = "null";
  openBadgeBackgroundColor = "null";
  openBadgeBorderColor = "null";
  openBadgeTextColor = "null";
  separatorColor = "null";
  UnreadBadge = new SIQLauncherUnreadBadgeTheme();
}
//# sourceMappingURL=SIQConversationListItemTheme.js.map